module.exports = __webpack_public_path__ + "img/wa.b368cc57.svg";